// extracted by mini-css-extract-plugin
export default {"UserInitials":"UserInitials_UserInitials__OhcaI"};